import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";

const TransferCertificateList = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");

  useEffect(() => {
    // Fetch data from API
    const fetchData = async () => {
      setLoading(true); // Set loading state
      try {
        const response = await fetch("https://api.example.com/students"); // Replace with your API URL
        const data = await response.json();
        setFilteredData(data); // Set the data from API
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchData();
  }, []);

  const sampleData = [
    {
      passPhoto: "",
      admissionNumber: "A001",
      surName: "Smith",
      firstName: "John",
      lastName: "Doe",
      fathersFirstName: "James",
      mothersFirstName: "Mary",
      primaryContact: "9876543210",
      gender: "Male",
      class: "1",
      section: "A",
    },
    {
      passPhoto: "",
      admissionNumber: "A002",
      surName: "Johnson",
      firstName: "Emily",
      lastName: "Davis",
      fathersFirstName: "Michael",
      mothersFirstName: "Sarah",
      primaryContact: "9876543220",
      gender: "Female",
      class: "2",
      section: "B",
    },
    {
      passPhoto: "",
      admissionNumber: "A003",
      surName: "Williams",
      firstName: "David",
      lastName: "Brown",
      fathersFirstName: "Robert",
      mothersFirstName: "Linda",
      primaryContact: "9876543230",
      gender: "Male",
      class: "3",
      section: "C",
    },
    {
      passPhoto: "",
      admissionNumber: "A004",
      surName: "Jones",
      firstName: "Sophia",
      lastName: "Taylor",
      fathersFirstName: "William",
      mothersFirstName: "Elizabeth",
      primaryContact: "9876543240",
      gender: "Female",
      class: "4",
      section: "D",
    },
    {
      passPhoto: "",
      admissionNumber: "A005",
      surName: "Brown",
      firstName: "Lucas",
      lastName: "Miller",
      fathersFirstName: "Thomas",
      mothersFirstName: "Margaret",
      primaryContact: "9876543250",
      gender: "Male",
      class: "5",
      section: "A",
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      setFilteredData(sampleData);
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    const result = sampleData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        (student.admissionNumber.toLowerCase().includes(searchTerm) ||
          student.surName.toLowerCase().includes(searchTerm) ||
          student.firstName.toLowerCase().includes(searchTerm) ||
          student.lastName.toLowerCase().includes(searchTerm)) &&
        (selectedClass ? student.class === selectedClass : true) &&
        (selectedSection ? student.section === selectedSection : true)
      );
    });

    setFilteredData(result);
  }, [searchQuery]);

  const handleDownload = () => {
    const csvContent = [
      [
        "S.No",
        "Admission Number",
        "Name",
        "Father Name",
        "Mother Name",
        "Mobile No",
        "Gender",
        "Class",
        "Section",
      ].join(","),
      ...filteredData.map((row, index) =>
        [
          index + 1,
          row.admissionNumber,
          `${row.firstName} ${row.lastName}`, // Combined full name
          row.fathersFirstName,
          row.mothersFirstName,
          row.primaryContact,
          row.gender,
          row.class,
          row.section,
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "student_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const toRoman = (num) => {
    const romanNumerals = [
      { value: 1000, symbol: "M" },
      { value: 900, symbol: "CM" },
      { value: 500, symbol: "D" },
      { value: 400, symbol: "CD" },
      { value: 100, symbol: "C" },
      { value: 90, symbol: "XC" },
      { value: 50, symbol: "L" },
      { value: 40, symbol: "XL" },
      { value: 10, symbol: "X" },
      { value: 9, symbol: "IX" },
      { value: 5, symbol: "V" },
      { value: 4, symbol: "IV" },
      { value: 1, symbol: "I" },
    ];

    let result = "";
    for (let i = 0; i < romanNumerals.length; i++) {
      while (num >= romanNumerals[i].value) {
        result += romanNumerals[i].symbol;
        num -= romanNumerals[i].value;
      }
    }
    return result;
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", textAlign: "start" }}>
            Tc Student List
          </Typography>
          <Box sx={{ flexGrow: 1 }} /> {/* Pushes the button to the right */}
          <Button
              variant="contained"
              color="secondary"
              onClick={handleDownload}
              sx={{ marginRight: 2 }}
            >
              Download
            </Button>
         
        </Box>

          <Box display="flex" mb={3} flexWrap="wrap">
            <TextField
              label="Search by Admission Number"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }} // Reduced space for search bar
            />
            <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
              <InputLabel>Select Class</InputLabel>
              <Select
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                {[...Array(10).keys()].map((i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    Class {toRoman(i + 1)} {/* Displaying Roman numeral */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 120, marginRight: 35 }}>
              <InputLabel>Select Section</InputLabel>
              <Select
                value={selectedSection}
                onChange={(e) => setSelectedSection(e.target.value)}
              >
                {["A", "B", "C", "D"].map((section) => (
                  <MenuItem key={section} value={section}>
                    Section {section}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box sx={{ flexGrow: 1 }} />
            <Button
            variant="contained"
            sx={{
              backgroundColor: "#4caf50", // Custom green color
              color: "white",
              "&:hover": {
                backgroundColor: "#388e3c", // Darker green for hover
              },
            }}
            onClick={() => navigate("/StudentTransferForm")}
          >
            Transfer Form
          </Button>
            {/* <Button
              variant="contained"
              sx={{
                backgroundColor: "#4caf50", // Custom green color
                color: "white",
                "&:hover": {
                  backgroundColor: "#388e3c", // Darker green for hover
                },
              }}
              onClick={() => navigate("/NewAdmissionForm")}
            >
              New Admission
            </Button> */}
          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                    }}
                  >
                    Pass Photo
                  </TableCell>
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                    }}
                  >
                    Class
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                    }}
                  >
                    Section
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Father Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Mother Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                    }}
                  >
                    Gender
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                    }}
                  >
                    Document
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.admissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column", // Stack items vertically
                          justifyContent: "center", // Center the content vertically
                          alignItems: "center", // Center the content horizontally
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Avatar
                            src={row.passPhoto}
                            alt="Pass Photo"
                            sx={{ width: 25, height: 25, objectFit: "cover" }}
                          />
                          <Typography sx={{ marginLeft: "8px" }}>
                            {" "}
                            {row.admissionNumber}{" "}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "3px", textAlign: "center" }}>
        {row.admissionNumber}
      </TableCell> */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {toRoman(parseInt(row.class))}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.section}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >{`${row.firstName} ${row.lastName}`}</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.fathersFirstName}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.mothersFirstName}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.primaryContact}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.gender}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: "4px",
                          }}
                        >
                          <Button
                            type="button"
                            onClick={() => navigate(`/TransferCertificate/${row.admissionNumber}`)}
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "white",
                              fontSize: "0.6rem", // Reduces the font size
                              // padding: "5px 10px",  // Reduces the padding
                              height: "25px", // Reduces the height
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            Transfer Certificate
                          </Button>
                          {/* View */}
                          {/* <Button
                            type="button"
                            onClick={() => navigate("/BonafideDoc")}
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "white",
                              fontSize: "0.6rem", // Reduces the font size
                              // padding: "5px 10px",  // Reduces the padding
                              height: "25px", // Reduces the height
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            Bonafide
                          </Button> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TransferCertificateList;